import { render, staticRenderFns } from "./locale-changer.vue?vue&type=template&id=c4332216&"
import script from "./locale-changer.vue?vue&type=script&lang=js&"
export * from "./locale-changer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports